var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',[_c('h1',[_vm._v("客户服务")])]),_c('div',{staticClass:"content"},[_c('h1',[_vm._v("牛卡福统一客服电话：")]),_c('div',{staticClass:"tel"},[_c('i'),_c('span',[_vm._v("400-958-7888")])])])])
}]

export { render, staticRenderFns }